import { Box, Icon, List, Paragraph, Text } from '@zillow/constellation-10';
import { IconSparkleFilled } from '@zillow/constellation-icons';

type Props = {
  isIntroModal?: boolean;
  isRoomForRent?: boolean;
};

const ApplicationsBenefitsContent = ({ isIntroModal = false, isRoomForRent = false }: Props) => (
  <>
    <Paragraph css={{ marginTop: '600' }}>
      {isIntroModal
        ? 'Enable Zillow applications so renters can apply directly from your listing. You’ll automatically receive these benefits:'
        : 'You’ll automatically receive these benefits:'}
    </Paragraph>
    <List.Root>
      <List.Item css={{ paddingBlock: '0' }}>Credit report from identity verified applicants</List.Item>
      <List.Item css={{ paddingBlock: '0' }}>Background check (includes eviction &amp; criminal record)</List.Item>
      <List.Item css={{ paddingBlock: '0' }}>Income &amp; employment history</List.Item>
      <List.Item css={{ paddingBlock: '0' }}>Residence history &amp; previous landlord contacts</List.Item>
    </List.Root>
    {!isRoomForRent && (
      <Box css={{ marginTop: '600', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Icon render={<IconSparkleFilled />} size="md" css={{ color: 'icon.accent.brand.hero', marginRight: '200' }} />
        <Text textStyle="body-sm">
          Your listing gets an additional promotion when you choose to receive Zillow applications
        </Text>
      </Box>
    )}
  </>
);

export default ApplicationsBenefitsContent;
